import { LoanTooSmallContactInfo } from '../../cards/contact-info-short/small-loan';
import EarlyKickOut from '../../cards/early-kick-out';
import RefiLiens from '../../cards/refi-liens';
import { Branch, Card, End } from '../../components/deck';
import { isRefinanceLargeEnough } from '../../modules/loan-size';

/**
 * Gets your liens then branches to an early termination if your loan size
 *   is too small.
 *
 * @param {*} continuation - Path to continue on if validation passes
 */
export const RefiLiensBranch = (continuation) =>
  Card(
    RefiLiens,
    Branch(
      {
        loanTooSmall: Card(LoanTooSmallContactInfo, Card(EarlyKickOut, End()))
      },
      ({ model }) => {
        // Check if the loan is large enough.
        // Loan amount is calculated by property value plus cashout amount
        if (!isRefinanceLargeEnough(model)) {
          return 'loanTooSmall';
        }
        return null;
      },
      continuation
    )
  );



// WEBPACK FOOTER //
// ./src/decks/branches/refi-liens.js